import { cloudChiprApi } from "../../../../services/cloudchipr.api";

export const createV2UsersMeOffHoursSchedulesSelector =
  cloudChiprApi.endpoints.postV2UsersMeSchedules.select;
